import { Ruler } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';

const RING_SIZES = Array.from({ length: 19 }, (_, i) => i + 8);

const GUIDES = {
  Bracciali: {
    steps: [
      'Avvolgi un metro da sarta (o una striscia di carta) attorno al polso, appena sopra l’osso.',
      'Tienilo aderente senza stringere e segna il punto in cui si sovrappone.',
      'Misura la lunghezza e aggiungi 1–2 cm per una vestibilità comoda: la tabella lo fa per te.',
    ],
    head: ['Circonferenza polso', 'Misura bracciale'],
    rows: [
      ['13 – 14 cm', '15 cm'], ['14 – 15 cm', '16 cm'], ['15 – 16 cm', '17 cm'], ['16 – 17 cm', '18 cm'],
      ['17 – 18 cm', '19 cm'], ['18 – 19 cm', '20 cm'], ['19 – 20 cm', '21 cm'],
    ],
    note: 'Sei indeciso tra due misure? Scegli la più grande, oppure passa in showroom: ti aiutiamo noi.',
  },
  Anelli: {
    steps: [
      'Avvolgi una striscia di carta o un filo attorno alla base del dito, senza stringere.',
      'Segna il punto in cui si sovrappone e misura la lunghezza in millimetri: è la circonferenza.',
      'Cerca la circonferenza in tabella. In alternativa misura il diametro interno di un anello che già porti.',
    ],
    head: ['Taglia', 'Circonferenza', 'Diametro'],
    rows: RING_SIZES.map((n) => [`${n}`, `${40 + n} mm`, `${((40 + n) / Math.PI).toFixed(1).replace('.', ',')} mm`]),
    note: 'Misura a fine giornata, quando le dita sono leggermente più grandi. Tra due taglie scegli la più grande, oppure passa in showroom: la misuriamo noi.',
  },
};

export const SizeGuide = ({ category = 'Bracciali' }) => {
  const g = GUIDES[category];
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button type="button" className="inline-flex items-center gap-1.5 text-small text-bordeaux underline underline-offset-4 hover:text-ink transition-colors duration-hover" data-testid="size-guide-trigger">
          <Ruler className="w-3.5 h-3.5" /> Come trovare la tua misura
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-md max-h-[88vh] overflow-y-auto bg-ivory rounded-2xl" data-testid="size-guide-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-ink">Come trovare la tua misura</DialogTitle>
        </DialogHeader>
        <ol className="space-y-3 text-sm text-ink/80 leading-relaxed">
          {g.steps.map((s, i) => (
            <li key={i} className="flex gap-3">
              <span className="w-6 h-6 rounded-full bg-bordeaux text-ivory text-xs flex items-center justify-center flex-shrink-0">{i + 1}</span>
              {s}
            </li>
          ))}
        </ol>
        <table className="w-full text-sm mt-2" data-testid="size-guide-table">
          <thead>
            <tr className="text-eyebrow text-muted border-b border-line">
              {g.head.map((h, i) => (
                <th key={h} className={`py-2 font-normal ${i === g.head.length - 1 ? 'text-right' : 'text-left'}`}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {g.rows.map((row) => (
              <tr key={row.join()} className="border-b border-line/60">
                {row.map((c, i) => (
                  <td key={i} className={`py-1.5 tabular-nums ${i === 0 ? 'text-ink font-medium' : 'text-ink/75'} ${i === row.length - 1 ? 'text-right' : ''}`}>{c}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        <p className="text-xs text-muted leading-relaxed">{g.note}</p>
      </DialogContent>
    </Dialog>
  );
};
